"use client";

import { useState, useEffect, useCallback } from "react";
import { mockHospitals, type Hospital } from "@/data/mockData";

const LS_KEY = "cc_fav_hospitals";

function load(): number[] {
  if (typeof window === "undefined") return [];
  try {
    const raw = window.localStorage.getItem(LS_KEY);
    if (raw) {
      const arr = JSON.parse(raw);
      if (Array.isArray(arr)) return arr.map((x) => Number(x)).filter((n) => Number.isFinite(n));
    }
  } catch {}
  return [];
}

function save(ids: number[]) {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(LS_KEY, JSON.stringify(ids));
  } catch {}
}

export function useFavorites() {
  const [ids, setIds] = useState<number[]>([]);

  useEffect(() => {
    setIds(load());
  }, []);

  const isFavorite = useCallback((hospitalId: number) => ids.includes(hospitalId), [ids]);

  const toggleFavorite = useCallback((hospitalId: number) => {
    setIds((prev) => {
      const next = prev.includes(hospitalId)
        ? prev.filter((x) => x !== hospitalId)
        : [...prev, hospitalId];
      save(next);
      return next;
    });
  }, []);

  const favoriteHospitals: Hospital[] = ids
    .map((id) => mockHospitals.find((h) => h.id === id))
    .filter((h): h is Hospital => Boolean(h));

  return { ids, isFavorite, toggleFavorite, favoriteHospitals };
}
